
export const especie = [
  "Bovino",
  "Suíno",
  "Ovino",
  "Caprino",
  "Equino",
  "Aves",
  "Outras espécies pecuárias",
];


export const finalidade_producao_valor_estatico = [
  'Leite',
  'Carne',
  'Outros',
];

export const nutriente = [
  "Aplicação de corretivos",
  "Adubação verde",
  "Aplicação de estrume",
  "Aplicação de chorume",
  "Aplicação de digerido de Unidade de Biogás",
  "Aplicação de sedimentos depositados nos orgãos de armazenamento de efluentes pecuários",
  "Mistura de efluentes pecuários e seus derivados",
  "Aplicação de composto",
];

export const classe = [
  "MA - Muito Alto",
  "A - Alto",
  "M - Médio",
  "B - Baixo",
  "MB - Muito Baixo",
];

export const calcario = [
  "Calcário calcítico (constituído apenas por carbonato de cálcio)",
  "Calcário magnesiano (teor de óxido de magnésio igual ou superior a 3%)",
  "Calcário dolomítico (constituídos por carbonato de cálcio e carbonato de magnésio,\n mas com teor de óxido de magnésio igual ou superior a 12 %)",
];

export const parqueamento = [
  "Vedação/cerca fixa",
  "Cerca móvel",
  "Cerca elétrica",
  "Outras",
];

export const pontodeagua = [
  "Bebedouro",
  "Charca",
  "Cisterna",
  "Tanque",
  "Reservatório",
  "Outros",
  "Não existem",
];

export const pastagem = [
  "grau de cobertura elevado - ≥ 80%",
  "grau de cobertura médio – > 40% e < 80%",
  "grau de cobertura fraco - ≤ 40%",
];

export const grauinfestante = [
  "grau de infestação elevado - ≥ 30%",
  "grau de infestação médio – > 15% e < 30%",
  "grau de infestação baixo - ≤ 15%",
];

export const tipoIntervencao = ["Corte", "Arranque", "Outro"];
export const unidade_medida_mm = ["mm/m2", "m3/ha"];
export const unidade_medida_Kg_lt = ["Kg", "Lt", 'g/kg', 'g/L'];
export const unidade_medida_Kg_m3 = ["Kg/ha", "m3/ha"];
export const unidade_medida_Kg_l_t = ["Kg", "L", "Ton"];
export const unidade_medida_Km3_t = ["m3", "t"];
export const unidade_medida_Kw = ["kWh/t", "kWh/ha"];

export const sementeira = [
  "Sementeira",
  "Ressementeira",
  "Melhoria da pastagem",
];

export const pepac = [
  "AB",
  "PRODI",
  "MPP",
  "PFO",
  "SD",
  "ENR",
  "PB",
  "UEA",
  "AZPGMS",
  "AZMN",
  "AZDISMVC",
  "AZCVVGPC",
  "AZACA",
  "Não Aplicável",
];

export const texturasolo = ["ARG", "FRA", "ARE", "FAG", "Não Aplicável",];

export const modoproducao = ["CV", "PRODI", "AB", "C1", "C2", "C3", "Não Aplicável"];

export const boasPraticas = [
  "BPA",
  "M.MÍN",
  "SEM.D",
  "C.NÍV",
  "COB",
  "BORD",
  "BCE",
  "REF",
  "SEB",
  "RES",
  "P.AR",
  "Não Aplicável",
];
export const modoProducao = [
  "Produção Biológica",
  "Produção Integrada",
];

export const nomebiocida = [
  "Equisetum arvense",
  "Cloridrato de quitosano",
  "Hidróxido de cálcio",
  "Lecitina",
  "Salix spp. cortex",
  "Vinagre",
  "Frutose",
  "Hidrogenocarbonato de sódio",
  "Fosfato diamónico",
  "Soro de leite",
  "Óleo de girassol",
  "Peróxido de hidrogénio",
  "Urtica spp.",
  "Carvão vegetal com bentonite",
  "Cloreto de sódio",
  "Pó de sementes de mostarda",
  "Cerveja",
  "Talco E553B",
  "Óleo de cebola",
  "L-cisteína (E 920)",
  "Leite de vaca",
  "Extrato de Bolbo de Allium cepa L.",
  "Quitosano",
];

export const operacoes = [
  "Aplicação de corretivos",
  "Fertilização fundo",
  "Adubação verde",
  "Aplicação de estrume",
  "Aplicação de chorume",
  "Fertilização cobertura",
  "Fertirrigação",
];

export const operacaocultural = [
  "Aplicação de corretivos",
  "Fertilização fundo",
  "Adubação verde",
  "Aplicação de estrume",
  "Aplicação de chorume",
  "Fertilização cobertura",
  "Fertirrigação",
];
export const operacaocultural_aux = [
  "Aplicação de corretivos",
  "Fertilização fundo",
  "Fertilização foliar",
  "Adubação verde",
  "Aplicação de estrume",
  "Aplicação de chorume",
  "Fertilização cobertura",
  "Fertirrigação",
].map(item => ({
  value: item,
  label: item,
}));
export const fertilizacao = [
  "Aplicação de corretivos",
  "Fertilização fundo",
  "Adubação verde",
  "Aplicação de estrume",
  "Aplicação de chorume",
  "Fertilização cobertura",
];

export const tipoFertilizacao = [
  "Aplicação de corretivos",
  "Fertilização fundo",
  "Aplicação de estrume",
  "Aplicação de chorume",
  "Fertilização cobertura",
  "Fertirrega",
];

export const confirm = ["Sim", "Não"];
export const tres_um_dois = [
  "Equipamento a baixa pressão",
  "Equipamento de injeção direta",
  "Outro tipo de equipamento",
];
export const tres_um_tres = [
  "Chorume incorporado até 4 horas após a distribuição",
  "Chorume incorporado mais de 4 horas após a distribuição",
];
export const analise_foliar_1_3_classificacao = [
  "Insuficiente",
  "Suficiente",
  "Elevado",
];

export const tres_um_quatro = [
  "Antes da sementeira (em fundo)",
  "Em sementeira direta",
  "Sobre cultura já instalada (em cobertura)",
];
export const tres_dois_dois = [
  "Estrume ou outra F.O. incorporado até 24 horas após a distribuição",
  "Estrume ou outra F.O. incorporado mais de 24 horas após a distribuição",
];

export const origem = [
  "Água de rega",
  "Fertilização de Fundo com Fertilizantes Orgânicos",
  "Fertilização de Fundo com Fertilizantes Inorgânicos",
  "Fertilização de Cobertura com Fertilizantes Orgânicos",
  "Fertilização de Cobertura com Fertilizantes Inorgânicos",
];

export const fertilizante = [
  "Estrume",
  "Chorume",
  "Mistura de fluentes pecuários",
  "Digerido de Unidade de Biogás",
  "Sedimentos depositados nas lagoas de armazenamento de efluentes pecuários",
  "Composto com origem em efluentes pecuários ou seus equiparados",
  "Outro tipo de Composto",
  "Outro tipo de Fertilizante Orgânico",
  "Fertilizante de síntese",
];

export const pecuaria = [
  "Bovino",
  "Suíno",
  "Ovino",
  "Caprino",
  "Aves",
  "Equídeos",
  "Leporídeos",
  "Outras espécies pecuárias",
];

export const classeFertilizacao = [
  "MA - Muito Alto",
  "A - Alto",
  "M - Médio",
  "B - Baixo",
  "MB - Muito Baixo"
]

export const drapToChoose = [
  "Norte",
  "Centro",
  "Lisboa e Vale do Tejo",
  "Alentejo",
  "Algarve",
  "Açores",
  "Madeira",
];
export const eficiencia_2_1_grupos_homo = [
  "Bovinos Machos com < 6 Meses",
  "Bovinos Fêmeas com < 6 Meses",
  "Bovinos Machos de 6 Meses a < 1 ano",
  "Bovinos Fêmeas de 6 Meses a < 1 ano",
  "Bovinos Machos de 1 ano a < 2 anos",
  "Bovinos Fêmeas de 1 ano a < 2 anos",
  "Bovinos Machos com ≥ 2 anos",
  "Bovinos Fêmeas com ≥ 2 anos",
];